import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(theme => ({
    main: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "2.5rem",
        paddingTop: "1.5rem",
    },

    uploadContainer: {
        display: "flex",
        flexDirection: "column",
        gap: "1rem",
        textAlign: "center",
        color: "#555",
        fontSize: "1rem",
        width: "100%",
        alignItems: "center",
    },

    inputContainer: {
        display: "flex",
        flexDirection: "column",
        gap: "0.4rem",
        width: "100%",
    },

    input: {
        borderRadius: "0.3rem",
        border: "1px solid #D0D0D0",
        backgroundColor: "#FFF",
        padding: "0.75rem 0.5rem",
        outline: "none",
        fontSize: "1rem",
    },

    buttonAddImage: {
        minWidth: "65%",
        height: "50px",
        boxShadow:
            "0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)",
        marginTop: "5px",
        marginBottom: "15px",
        textTransform: "none",
        backgroundColor: "#EA3458",
        border: "none",
        color: "#FFF",
        fontSize: "0.875rem",
        borderRadius: "4px",
        transition: "all 0.2s ease-in-out",
        "&:hover": {
            backgroundColor: "#EA3458",
            opacity: "0.8",
        },
    },

    deleteBannerSpan: {
        textDecoration: "underline",
        color: "#BCBCBC",
        cursor: "pointer",
        fontWeight: "500",
        marginBottom: "1rem",
    },

    buttonSave: {
        color: "#fff",
        minWidth: "100%",
        height: "50px",
        boxShadow:
            "0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)",
        marginTop: "5px",
        marginBottom: "15px",
        textTransform: "none",
        backgroundColor: "#EA3458",

        '&:hover':{
            boxShadow: "none !important",
            backgroundColor: "#EA3458 !important"
        }
    }
}))